// import ProductCard from "../components/ProductCard";
import CategoryCard from "../components/CategoryCard";
import { featuredProducts, categories } from "../data/products";
import "./Home.css";
import { Link } from "react-router-dom";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Home = () => (
  <div className="content">
    <header
      className="hero section-offwhite"
      style={{
        background: `url(/assets/photos/HomepageBannerImage.jpg) top/cover no-repeat`,
      }}
    >
      <div className="hero__overlay" />
      <div className="hero__content animate-fadein">
        <h1 className="hero__title">Elevate Your Style</h1>
        <p className="hero__subtitle">
          "If you're someone who values ease over excess… You'll probably feel at home here."
        </p>
        <Link className="hero__button" to="/ExploreAll" onClick={scrollToTop}>
          Explore Our Collection
        </Link>
      </div>
    </header>
    <section className="categories section-offwhite elegant-section" id="Categories">
      <h2 className="section-title">Shop by Category</h2>
      <div className="categories__list">
        {categories.map((category) => (
          <CategoryCard key={category.id} category={category} />
        ))}
      </div>
    </section>
    <section className="discover section-olive elegant-section">
      <div className="discover-divider">
        <span className="divider-icon">&#10024;</span>
      </div>
      <h2 className="section-title">Discover More</h2>
      <p className="discover-desc">Browse our full collection of luxury clothing and accessories.</p>
      <div className="discover__button-container">
        <Link
          className="discover__button large-btn"
          to="/ExploreAll"
          onClick={scrollToTop}
        >
          Explore All
        </Link>
      </div>
    </section>
  </div>
);

export default Home;
